document.addEventListener('DOMContentLoaded', function() {
  const mainMenu = document.querySelector('.menu-drawer__navigation > .menu-drawer__menu');

  // Prevenir comportamiento por defecto en detalles de primer nivel
  document.querySelectorAll('.menu-drawer__menu > li > details').forEach(detail => {
    detail.addEventListener('toggle', (e) => {
      e.preventDefault();
    });
  });
  
  // Manejar segundo y tercer nivel
  const allDetails = document.querySelectorAll('.menu-drawer__submenu details');
  
  allDetails.forEach(detail => {
    const summary = detail.querySelector('summary');
    const submenu = detail.querySelector('.menu-drawer__submenu');
    
    if (summary && submenu) {
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Toggle el estado del details
        const isOpen = detail.hasAttribute('open');

        // Cerrar otros collapsibles del mismo nivel
        if (submenu.closest('.menu-drawer__submenu')) {
          const parentUl = detail.closest('ul');
          if (parentUl) {
            parentUl.querySelectorAll('details').forEach(otherDetail => {
              if (otherDetail !== detail && otherDetail.hasAttribute('open')) {
                otherDetail.removeAttribute('open');
                const otherSubmenu = otherDetail.querySelector('.menu-drawer__submenu');
                if (otherSubmenu) {
                  otherSubmenu.classList.remove('submenu-open');
                }
                
                const otherSummary = otherDetail.querySelector('summary');
                const otherArrow = otherSummary.querySelector('.icon-arrow');
                const otherMinus = otherSummary.querySelector('.icon-minus');
                if (otherArrow && otherMinus) {
                  otherArrow.style.display = 'block';
                  otherMinus.style.display = 'none';
                }
              }
            });
          }
        }
        
        detail.toggleAttribute('open');
        
        if (submenu.closest('.menu-drawer__submenu')) {
          // Asegurarnos de que el contenedor padre tenga altura suficiente
          const parentSubmenu = submenu.closest('.menu-drawer__inner-submenu');
          if (parentSubmenu) {
            parentSubmenu.style.height = 'auto';
          }
          
          submenu.classList.toggle('submenu-open');
          
          // Actualizar íconos
          const arrowIcon = summary.querySelector('.icon-arrow');
          const minusIcon = summary.querySelector('.icon-minus');
          
          if (arrowIcon && minusIcon) {
            if (isOpen) {
              arrowIcon.style.display = 'block';
              minusIcon.style.display = 'none';
            } else {
              arrowIcon.style.display = 'none';
              minusIcon.style.display = 'block';
            }
          }
        }
      });
    }
  });

  // Manejar los botones de volver
  const backButtons = document.querySelectorAll('.menu-drawer__close-button');
  backButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const parentSubmenu = button.closest('.menu-drawer__submenu');
      
      if (parentSubmenu) {
        // Resetear alturas antes de la transición
        const innerSubmenu = parentSubmenu.querySelector('.menu-drawer__inner-submenu');
        if (innerSubmenu) {
          innerSubmenu.style.height = '';
        }
        
        mainMenu.style.transform = 'translateX(0)';
        parentSubmenu.classList.remove('submenu-open');
        
        // Resetear íconos cuando se cierra el menú
        const parentDetails = parentSubmenu.closest('details');
        if (parentDetails) {
          const summary = parentDetails.querySelector('summary');
          const arrowIcon = summary.querySelector('.icon-arrow');
          const minusIcon = summary.querySelector('.icon-minus');
          
          if (arrowIcon && minusIcon) {
            arrowIcon.style.display = 'block';
            minusIcon.style.display = 'none';
          }
          
          parentDetails.removeAttribute('open');
        }
      }
    });
  });

  // Prevenir propagación en los submenús
  const allSubmenus = document.querySelectorAll('.menu-drawer__submenu');
  allSubmenus.forEach(submenu => {
    submenu.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  // Inicializar el estado de los íconos
  document.querySelectorAll('.menu-drawer__submenu-summary').forEach(summary => {
    const arrowIcon = summary.querySelector('.icon-arrow');
    const minusIcon = summary.querySelector('.icon-minus');
    
    if (arrowIcon && minusIcon) {
      arrowIcon.style.display = 'block';
      minusIcon.style.display = 'none';
    }
  });

  // Manejar el cierre del drawer principal
  const mainDrawerDetails = document.getElementById('Details-menu-drawer-container');
  if (mainDrawerDetails) {
    mainDrawerDetails.addEventListener('close', () => {
      // Resetear todos los submenús cuando se cierra el drawer principal
      allDetails.forEach(detail => {
        const summary = detail.querySelector('summary');
        const submenu = detail.querySelector('.menu-drawer__submenu');
        const arrowIcon = summary?.querySelector('.icon-arrow');
        const minusIcon = summary?.querySelector('.icon-minus');
        
        if (submenu) {
          submenu.classList.remove('submenu-open');
        }
        
        if (arrowIcon && minusIcon) {
          arrowIcon.style.display = 'block';
          minusIcon.style.display = 'none';
        }
        
        detail.removeAttribute('open');
      });

      // Resetear la posición del menú principal
      if (mainMenu) {
        mainMenu.style.transform = 'translateX(0)';
      }
    });
  }
});

